import { createFeatureSelector, createSelector } from '@ngrx/store';
import { KnBrAddressState, KN_BR_ADDRESS_FEATURE } from './kn-br-address.state';

export const getOneTimeAddressState = createFeatureSelector<KnBrAddressState>(KN_BR_ADDRESS_FEATURE);

export const getOneTimeAddress = createSelector(
  getOneTimeAddressState,
  (state: KnBrAddressState) => state.oneTimeAddress
);
